import { storeUrlFormat } from '../config'

export const storeList = ['sg', 'ca', 'jp', 'tw', 'hk', 'au', 'en', 'fr', 'gr', 'it', 'de', 'es', 'pl', 'uk', 'us', 'nordic', 'my', 'asean']

// store:language
export const languageCode = {
  sg: 'en',
  jp: 'jp',
  tw: 'tw',
  hk: 'en',
  au: 'en',
  en: 'en',
  gr: 'en',
  fr: 'fr',
  it: 'it',
  de: 'de',
  es: 'es',
  pl: 'pl',
  us: 'en',
  ca: 'en',
  uk: 'en',
  nordic: 'en',
  my: 'en',
  asean: 'en'

}

// store: 2-char countrycode
export const storeCountryCode = {
  sg: 'sg',
  jp: 'jp',
  tw: 'tw',
  hk: 'hk',
  au: 'au',
  en: 'ie',
  gr: 'gr',
  fr: 'fr',
  it: 'it',
  de: 'de',
  es: 'es',
  pl: 'pl',
  us: 'us',
  ca: 'ca',
  uk: 'uk',
  nordic: 'dk',
  my: 'my',
  asean: 'ph'

}

export function storeUrl(code) {
  // //window.console.log(storeUrlFormat,code)
  return storeUrlFormat.replace('{code}', code)
}

export function getStoreCodeByUrl(url) {
  url = url.toLowerCase()
  const format = new RegExp(storeUrlFormat.replace(/\//ig, '\\/').replace('{code}', '([a-z,A-Z,0-9]+?)'), 'i')
  //window.console.log(format)
  let code = url.match(format)
  if (code && code[1]) {
    return code[1]
  }
  return null
}

export function getStoreCountryNameByCode(code = 'sg') {
  let name = code;
  switch(code.toLowerCase()) {
    case 'sg': name = 'Singapore'; break;
    case 'jp': name = 'Japan'; break;
    case 'tw': name = 'Taiwan'; break;
    case 'hk': name = 'Hong Kong'; break;
    case 'au': name = 'Australia'; break;
    case 'en': name = 'Pan Euro'; break;
    case 'gr': name = 'Greece'; break;
    case 'fr': name = 'France'; break;
    case 'it': name = 'Italy'; break;
    case 'de': name = 'Germany'; break;
    case 'es': name = 'Spain'; break;
    case 'pl': name = 'Poland'; break;
    case 'us': name = 'United States'; break;
    case 'ca': name = 'Canada'; break;
    case 'uk': name = 'United Kingdom'; break;
    case 'nordic': name = 'Nordic'; break;
    case 'my': name = 'Malaysia'; break;
    case 'asean': name = 'Asian'; break;
    default: name = code.toUpperCase();
  }
  // console.log({name});
  return name
}